(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["desitech-x8-emergent"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = (scope = document) => {
    scope.querySelectorAll('.x8-page:not([data-initialized])').forEach(root => {
      root.dataset.initialized = 'true';
      const abort = new AbortController();
      const signal = abort.signal;
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      let paused = reduced.matches || root.dataset.motion === 'false';
      let timers = [], frames = [], observers = [];
      const find = s => root.querySelector(s);
      const all = s => root.querySelectorAll(s);
      const interval = (fn, ms) => { const id = setInterval(() => {if(!document.hidden && !paused) fn();},ms);timers.push(id);return id; };
      const observer = (fn, options) => {const o=new IntersectionObserver(fn,options);observers.push(o);return o;};
      const motionButton = find('.x8-motion-toggle');
      const applyPause = () => {
        root.classList.toggle('x8-paused',paused);
        motionButton.textContent=paused?root.dataset.resume:root.dataset.pause;
        motionButton.setAttribute('aria-pressed',String(paused));
        all('video').forEach(v=>{if(paused)v.pause();else v.play().catch(()=>{});});
      };
      motionButton.addEventListener('click',()=>{paused=!paused;applyPause();},{signal});
      reduced.addEventListener('change',()=>{paused=reduced.matches;applyPause();},{signal});
      applyPause();
      root.classList.add('x8-ready');
      const reveal=observer(entries=>entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('in');reveal.unobserve(e.target);}}),{threshold:.08});
      all('[data-rv]').forEach(el=>reveal.observe(el));
      const frame=find('#tilt'),aura=find('#aura'),slider=find('#watt'),read=find('#wattv');
      slider.addEventListener('input',()=>{const v=Number(slider.value);read.textContent=v;aura.style.opacity=.25+v/320*.7;aura.style.background=v>200?'radial-gradient(ellipse at center,rgba(255,158,0,.35),transparent 65%)':'radial-gradient(ellipse at center,rgba(0,240,255,.35),transparent 65%)';},{signal});
      frame.addEventListener('pointermove',e=>{if(paused||e.pointerType==='touch')return;const r=frame.getBoundingClientRect();frame.style.transform=`perspective(1000px) rotateY(${((e.clientX-r.left)/r.width-.5)*22}deg) rotateX(${(.5-(e.clientY-r.top)/r.height)*18}deg)`;},{signal});
      frame.addEventListener('pointerleave',()=>{frame.style.transform='none';},{signal});
      const words=['MOBILE','LAPTOP','POWER BANK','EARBUDS','DRONE','TRIMMER','CAMERA','TABLET','SMARTWATCH','CONSOLE'];
      const chars='ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
      const board=find('#board'), ticker=find('#tick');
      const tiles=Array.from({length:10},()=>{const tile=document.createElement('span');tile.className='tile';const ch=document.createElement('span');ch.className='ch';tile.append(ch);board.append(tile);return ch;});
      const settle=word=>{tiles.forEach((c,i)=>c.textContent=word[i]||'\u00a0');ticker.textContent=word;};
      let wordIndex=0;settle(words[0]);
      interval(()=>{const word=words[++wordIndex%words.length];let step=0;const id=interval(()=>{step++;tiles.forEach((c,i)=>c.textContent=step>i*2+6?(word[i]||'\u00a0'):chars[Math.floor(Math.random()*chars.length)]);ticker.textContent=word.split('').map((c,i)=>step>i*2?c:chars[Math.floor(Math.random()*chars.length)]).join('');if(step>28){clearInterval(id);timers=timers.filter(x=>x!==id);settle(word);}},45);},3200);
      const count=find('#c320');
      const bento=observer(entries=>entries.forEach(e=>{if(!e.isIntersecting)return;e.target.classList.add('in');if(e.target.contains(count)&&!paused){const start=performance.now();const tick=now=>{if(signal.aborted)return;const progress=Math.min(1,(now-start)/1800);count.textContent=Math.round(320*(1-Math.pow(1-progress,3)));if(progress<1&&!paused)frames.push(requestAnimationFrame(tick));else count.textContent='320';};frames.push(requestAnimationFrame(tick));}bento.unobserve(e.target);}),{threshold:.15});
      all('#bgrid>.card').forEach(el=>bento.observe(el));
      const story=observer(entries=>entries.forEach(e=>{if(e.isIntersecting){all('.step').forEach(s=>s.classList.remove('active'));e.target.classList.add('active');}}),{rootMargin:'-35% 0px -35% 0px'});
      all('.step').forEach(el=>story.observe(el));
      let scrollPending=false;
      let scrollFrame;
      const updateScroll=()=>{scrollPending=false;if(signal.aborted)return;find('#hdr').classList.toggle('scrolled',window.scrollY>40);if(paused)return;const hero=find('.hero'),rect=hero.getBoundingClientRect(),p=Math.min(1,Math.max(0,-rect.top/hero.offsetHeight));find('[data-py="img"]').style.transform=`translateY(${p*90}px)`;find('[data-py="copy"]').style.transform=`translateY(${p*50}px)`;const vr=find('#vsec').getBoundingClientRect(),vp=(vr.top+vr.height/2-innerHeight/2)/(innerHeight/2+vr.height/2);find('#vsecvid').style.transform=`scale(1.18) translateY(${vp*-5}%)`;};
      window.addEventListener('scroll',()=>{if(!scrollPending){scrollPending=true;scrollFrame=requestAnimationFrame(updateScroll);}},{passive:true,signal});updateScroll();
      all('a[href^="#"]').forEach(a=>a.addEventListener('click',e=>{const target=find(a.getAttribute('href'));if(target){e.preventDefault();target.scrollIntoView({behavior:paused?'instant':'smooth',block:'start'});}},{signal}));
      const variant=find('#X8Variant');
      if(variant)variant.addEventListener('change',()=>{all('[data-x8-price]').forEach(el=>el.textContent=variant.selectedOptions[0].dataset.price);},{signal});
      const media=observer(entries=>entries.forEach(e=>{if(e.isIntersecting&&!paused)e.target.play().catch(()=>{});else e.target.pause();}),{rootMargin:'150px'});
      all('video').forEach(el=>media.observe(el));
      root.x8Cleanup=()=>{abort.abort();timers.forEach(clearInterval);frames.forEach(cancelAnimationFrame);cancelAnimationFrame(scrollFrame);observers.forEach(o=>o.disconnect());};
    });
  };
  initialize();
  document.addEventListener('shopify:section:load',event=>initialize(event.target));
  document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('.x8-page').forEach(root=>root.x8Cleanup?.()));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtx-creator-club"] && !Shopify.designMode) return;
  try {
    
(()=>{
const boot=()=>{document.querySelectorAll('[data-creator-club]').forEach(root=>{
 if(root.dataset.ready)return;root.dataset.ready='true';
 root.querySelectorAll('a[href^="#"]').forEach(a=>{a.removeAttribute('target');a.addEventListener('click',e=>{const t=document.getElementById(a.getAttribute('href').slice(1));if(!t)return;e.preventDefault();t.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});if(a.dataset.collabChoice){const s=root.querySelector('#CreatorCollab');if(s)s.value=a.dataset.collabChoice}})});
 const form=root.querySelector('#DesitechCreatorApplication');const params=new URLSearchParams(location.search);
 if(params.get('contact_posted')==='true'){const success=root.querySelector('[data-creator-success]');if(success)success.hidden=false;const fields=root.querySelector('[data-creator-fields]');if(fields)fields.hidden=true}
 root.querySelector('[data-creator-share]')?.addEventListener('click',async()=>{const url=location.origin+location.pathname;const status=root.querySelector('[data-creator-share-status]');try{await navigator.clipboard.writeText(url);if(status)status.textContent=root.querySelector('[data-creator-share]').dataset.copyLabel}catch(e){if(status)status.textContent=url}});
 if(form)form.addEventListener('submit',()=>{if(!form.checkValidity())return;const b=form.querySelector('[type="submit"]');if(b){b.setAttribute('aria-busy','true');setTimeout(()=>b.removeAttribute('aria-busy'),8000)}});
 })};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();document.addEventListener('shopify:section:load',boot);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtx-product-conversion"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('dtx-conversion')){
class DtxConversion extends HTMLElement{
 connectedCallback(){
  // Retain trust + FAQ layout, but hand the sticky cart back to the
  // existing, product-specific DesiTech/EarPods implementation.
  if(this.dataset.useClassicSticky==='true'){
    this.replaceBrand(document.body);
    return;
  }
  this.abort=new AbortController();this.opts={signal:this.abort.signal};this.bar=this.querySelector('[data-dtx-sticky]');this.buttons=[...this.querySelectorAll('[data-dtx-add],[data-dtx-buy]')];this.price=this.querySelector('[data-dtx-price]');
  try{this.variants=JSON.parse(this.querySelector('[data-dtx-variants]').textContent);this.messages=JSON.parse(this.querySelector('[data-dtx-messages]').textContent)}catch(e){this.variants=[];this.messages=[]}
  this.formatter=new Intl.NumberFormat(this.dataset.locale||'en-IN',{style:'currency',currency:this.dataset.currency||'INR',maximumFractionDigits:2});
  this.buttons.forEach(b=>b.addEventListener('click',()=>this.add(),this.opts));
  document.addEventListener('change',()=>requestAnimationFrame(()=>this.sync()),this.opts);document.addEventListener('on:variant:change',()=>this.sync(),this.opts);
  this.boot();this.timer=setInterval(()=>this.sync(),750);
  if(!matchMedia('(prefers-reduced-motion: reduce)').matches&&this.messages.length>1){let i=0;this.rotation=setInterval(()=>{i=(i+1)%this.messages.length;this.querySelector('[data-dtx-ticker]').textContent=this.messages[i]},4000)}
  document.addEventListener('shopify:section:unload',e=>{if(e.target.contains(this))this.disconnectedCallback()},this.opts);
 }
 boot(){
  this.root=document.querySelector('[data-dep-root],[data-c100-root],[data-sw-root],.ep-page,.x8-page,.section-main-product');
  if(this.root){this.replaceBrand(this.root);this.replaceBrand(document.body)}
  this.resize=new ResizeObserver(()=>document.body.style.setProperty('--dtx-sticky-height',`${Math.ceil(this.bar.getBoundingClientRect().height)+12}px`));this.resize.observe(this.bar);this.sync();
 }
 replaceBrand(root){
  const walker=document.createTreeWalker(root,NodeFilter.SHOW_TEXT);const nodes=[];while(walker.nextNode())nodes.push(walker.currentNode);
  nodes.forEach(n=>{if(!n.parentElement.closest('script,style,textarea')&&/chargingcable\.in/i.test(n.textContent))n.textContent=n.textContent.replace(/[A-Za-z0-9_.+-]+@chargingcable\.in/gi,'care@thedesitech.com').replace(/chargingcable\.in/gi,'The Desitech')});
  root.querySelectorAll('a[href]').forEach(a=>{try{if(/^mailto:/i.test(a.getAttribute('href'))&&/chargingcable\.in/i.test(a.getAttribute('href')))a.href='mailto:care@thedesitech.com';const u=new URL(a.href);if(/^(www\.)?chargingcable\.in$/i.test(u.hostname)){u.hostname='thedesitech.com';a.href=u.href}}catch(e){}});
 }
 getForm(){
  const roots=[...document.querySelectorAll('[data-dep-root],[data-c100-root],[data-sw-root],.ep-page,.x8-page,.section-main-product')];
  for(const root of roots){for(const form of root.querySelectorAll('form[action*="/cart/add"]')){if(form.querySelector('[name="add"],[data-ep-add]'))return form}}
 }
 nativeButton(form){return form?.querySelector('[name="add"],[data-ep-add]')}
 getVariant(form){
  const root=form.closest('[data-dep-root],[data-c100-root],[data-sw-root],.ep-page,.x8-page,.section-main-product');const picker=root?.querySelector('variant-picker,desitech-cover-picker,desitech-variant-picker');
  const id=form?.elements.namedItem('id')?.value;const variant=picker?.getVariantData?.();return variant||(this.variants||[]).find(v=>String(v.id)===String(id));
 }
 sync(){
  const form=this.getForm(),main=this.nativeButton(form);this.bar.hidden=!main;document.body.classList.toggle('dtx-has-sticky',!!main);if(!main)return;
  const id=form.elements.namedItem('id')?.value,v=this.getVariant(form),busy=main.getAttribute('aria-disabled')==='true'||main.getAttribute('aria-busy')==='true';
  const sold=!!id&&(v?.available===false||(main.disabled&&!busy&&!main.classList.contains('is-loading')));this.buttons.forEach(b=>{const label=!id?this.dataset.choose:sold?this.dataset.sold:b.hasAttribute('data-dtx-buy')?this.dataset.buy:this.dataset.add;if(b.textContent!==label)b.textContent=label;b.disabled=busy||sold;b.setAttribute('aria-busy',String(busy))});
  if(v&&Number.isFinite(Number(v.price)))this.price.textContent=this.formatter.format(Number(v.price)/100);
 }
 reveal(form){const target=form?.querySelector(':invalid')||form?.closest('product-form')?.querySelector('desitech-variant-picker,variant-picker,.dt-cover-options')||form;target?.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'center'});if(target?.matches('input,select,textarea'))target.focus({preventScroll:true})}
 add(){
  const form=this.getForm(),main=this.nativeButton(form);if(!main)return;if(!form.elements.namedItem('id')?.value){this.reveal(form);return}if(main.disabled||main.getAttribute('aria-disabled')==='true')return;
  const component=form.closest('product-form');if((component?.validate&&!component.validate())||!form.reportValidity()){this.reveal(form);return}main.click();this.sync();
 }
 disconnectedCallback(){this.abort?.abort();this.resize?.disconnect();clearInterval(this.timer);clearInterval(this.rotation);document.body.classList.remove('dtx-has-sticky');document.body.style.removeProperty('--dtx-sticky-height')}
}
customElements.define('dtx-conversion',DtxConversion);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtx-product-main"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
      var videos = document.querySelectorAll('video');
      videos.forEach(function(video) {
        video.play().catch(function(error) {
          console.error('Error attempting to play video:', error);
        });
      });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["earpods-emergent"] && !Shopify.designMode) return;
  try {
    
(()=>{
 const mounted=new WeakMap();
 function init(root){
  if(mounted.has(root))return;
  const abort=new AbortController(),signal=abort.signal,observers=[],timers=[];
  mounted.set(root,()=>{abort.abort();observers.forEach(x=>x.disconnect());timers.forEach(clearInterval);mounted.delete(root)});
  const motion=root.dataset.motion==='true'&&!matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(motion)root.classList.add('ep-motion');
  const reveal=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('is-visible');reveal.unobserve(e.target)}}),{threshold:.08});
  root.querySelectorAll('.reveal,.reveal-scale').forEach(e=>reveal.observe(e));observers.push(reveal);
  const slides=[...root.querySelectorAll('[data-ep-slide]')],thumbs=[...root.querySelectorAll('[data-ep-thumb]')];let active=0,manual=false;
  const show=i=>{active=i;slides.forEach((s,n)=>{s.classList.toggle('opacity-100',n===i);s.classList.toggle('opacity-0',n!==i);s.classList.toggle('scale-100',n===i);s.classList.toggle('scale-95',n!==i);s.setAttribute('aria-hidden',String(n!==i))});thumbs.forEach((b,n)=>{b.setAttribute('aria-pressed',String(n===i));b.classList.toggle('border-neutral-900',n===i);b.classList.toggle('border-neutral-200',n!==i);b.classList.toggle('scale-105',n===i)})};
  thumbs.forEach((b,i)=>b.addEventListener('click',()=>{manual=true;show(i)},{signal}));
  const gallery=root.querySelector('[data-ep-tilt]');let hovering=false;
  if(gallery){gallery.addEventListener('mouseenter',()=>hovering=true,{signal});gallery.addEventListener('mouseleave',()=>hovering=false,{signal})}
  if(motion&&slides.length>1)timers.push(setInterval(()=>{if(!manual&&!hovering&&!document.hidden)show((active+1)%slides.length)},4600));
  const variantsNode=root.querySelector('[data-ep-variants]'),select=root.querySelector('[data-ep-variant]')||root.querySelector('[data-ep-variant-input]'),form=root.querySelector('form.ep-product-form'),add=root.querySelector('[data-ep-add]'),stickyAdd=root.querySelector('[data-ep-sticky-add]'),stickyBuy=root.querySelector('[data-ep-sticky-buy]');if(!variantsNode||!select||!form||!add)return;const variants=JSON.parse(variantsNode.textContent);
  const update=()=>{const v=variants.find(x=>String(x.id)===select.value);if(!v)return;root.querySelectorAll('[data-ep-price]').forEach(e=>e.innerHTML=v.price);root.querySelectorAll('[data-ep-prepaid]').forEach(e=>e.innerHTML=v.prepaid);root.querySelectorAll('[data-ep-welcome]').forEach(e=>e.innerHTML=v.welcome);root.querySelectorAll('[data-ep-compare]').forEach(e=>{e.innerHTML=v.compare;e.hidden=!v.compare});const saving=root.querySelector('[data-ep-saving]');if(saving){saving.innerHTML=root.dataset.save+' '+v.saving;saving.hidden=!v.saving}const discount=root.querySelector('[data-ep-discount]');if(discount)discount.textContent=v.percent?v.percent+'% '+root.dataset.off:'USB-C';const stock=root.querySelector('[data-ep-stock]');if(stock)stock.textContent=v.available?root.dataset.stock:root.dataset.sold;add.disabled=!v.available;if(stickyAdd)stickyAdd.disabled=!v.available;if(stickyBuy)stickyBuy.disabled=!v.available;add.innerHTML=v.available?root.dataset.add+' · '+v.price:root.dataset.sold;if(stickyAdd)stickyAdd.textContent=v.available?root.dataset.stickyAdd:root.dataset.sold;if(stickyBuy)stickyBuy.textContent=v.available?root.dataset.stickyBuy:root.dataset.sold;};
  select.addEventListener('change',update,{signal});update();
  const triggerNativeAdd=()=>{if(add.disabled||add.getAttribute('aria-disabled')==='true')return;add.click()};
  if(stickyAdd)stickyAdd.addEventListener('click',triggerNativeAdd,{signal});
  if(stickyBuy)stickyBuy.addEventListener('click',triggerNativeAdd,{signal});
  const sticky=root.querySelector('[data-ep-sticky]');if(sticky){sticky.hidden=false;sticky.setAttribute('aria-hidden','false')}
  const ticker=root.querySelector('[data-ep-sticky-ticker]'),tickerData=root.querySelector('[data-ep-sticky-messages]');if(ticker&&tickerData){let messages=[];try{messages=JSON.parse(tickerData.textContent).filter(Boolean)}catch(e){}if(messages.length>1){let ti=0;timers.push(setInterval(()=>{ti=(ti+1)%messages.length;ticker.classList.add('is-changing');setTimeout(()=>{ticker.textContent=messages[ti];ticker.classList.remove('is-changing')},160)},3600))}}
  root.querySelectorAll('[data-ep-video-card]').forEach(card=>{const v=card.querySelector('video'),play=card.querySelector('[data-ep-play]'),mute=card.querySelector('[data-ep-mute]');v.muted=true;v.defaultMuted=true;v.setAttribute('muted','');v.setAttribute('playsinline','');v.setAttribute('autoplay','');let pausedByUser=false;
   const sync=()=>{play.setAttribute('aria-label',v.paused?root.dataset.play:root.dataset.pause);play.dataset.paused=String(v.paused);play.querySelector('span').innerHTML=v.paused?'<svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M7 4v16l14-8z"/></svg>':'<svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M6 4h4v16H6zm8 0h4v16h-4z"/></svg>'};
   play.addEventListener('click',()=>{if(v.paused){pausedByUser=false;v.play().catch(()=>{})}else{pausedByUser=true;v.pause()}},{signal});
   mute.addEventListener('click',()=>{v.muted=!v.muted;mute.setAttribute('aria-label',v.muted?root.dataset.unmute:root.dataset.mute);mute.setAttribute('aria-pressed',String(!v.muted));mute.style.backgroundColor=v.muted?'rgba(0,0,0,.5)':'#2563eb'},{signal});
   v.addEventListener('play',sync,{signal});v.addEventListener('pause',sync,{signal});sync();
   const io=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting&&!pausedByUser)v.play().catch(()=>{});else if(!e.isIntersecting)v.pause()}),{threshold:.25});io.observe(v);observers.push(io);
  });
  const shareBtn=root.querySelector('[data-ep-share]'),copyBtn=root.querySelector('[data-ep-copy]'),saveBtn=root.querySelector('[data-ep-save-product]');const shareData={title:document.title,url:location.href};
  if(shareBtn)shareBtn.addEventListener('click',async()=>{try{if(navigator.share){await navigator.share(shareData)}else if(navigator.clipboard){await navigator.clipboard.writeText(location.href)}}catch(e){}},{signal});
  if(copyBtn)copyBtn.addEventListener('click',async()=>{const label=copyBtn.querySelector('[data-ep-copy-label]');try{await navigator.clipboard.writeText(location.href);if(label){label.textContent='Copied';setTimeout(()=>label.textContent='Copy Link',1600)}}catch(e){}},{signal});
  if(saveBtn){const key='desitech:saved:'+root.dataset.productId,label=saveBtn.querySelector('[data-ep-save-label]'),icon=saveBtn.querySelector('[data-ep-save-icon]');const syncSaved=()=>{let saved=false;try{saved=localStorage.getItem(key)==='1'}catch(e){}saveBtn.classList.toggle('is-saved',saved);if(label)label.textContent=saved?'Saved':'Save';if(icon)icon.textContent=saved?'♥':'♡'};syncSaved();saveBtn.addEventListener('click',()=>{try{const saved=localStorage.getItem(key)==='1';if(saved)localStorage.removeItem(key);else localStorage.setItem(key,'1')}catch(e){}syncSaved()},{signal})}
  const slider=root.querySelector('[data-ep-slider]');if(slider){const range=slider.querySelector('input');if(range)range.addEventListener('input',()=>{slider.querySelector('[data-ep-before]').style.clipPath='inset(0 '+(100-Number(range.value))+'% 0 0)';slider.querySelector('[data-ep-handle]').style.left=range.value+'%'},{signal})}
 }
 const scan=scope=>scope.querySelectorAll('[data-ep-root]').forEach(init);
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>scan(document),{once:true});else scan(document);
 document.addEventListener('shopify:section:load',e=>scan(e.target));
 document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('[data-ep-root]').forEach(r=>mounted.get(r)?.()));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-GRQ"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
      var videos = document.querySelectorAll('video');
      videos.forEach(function(video) {
        video.play().catch(function(error) {
          console.error('Error attempting to play video:', error);
        });
      });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    


  document.addEventListener('DOMContentLoaded', function() {
      var videos = document.querySelectorAll('video');
      videos.forEach(function(video) {
        video.play().catch(function(error) {
          console.error('Error attempting to play video:', error);
        });
      });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["what-it"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const tabItems = document.querySelectorAll('.rb-tabs-item');
    const tabContentItems = document.querySelectorAll('.rb-tabs-content-item');

  
    tabItems.forEach((tabItem, index) => {
        tabItem.addEventListener('click', () => {
         
            tabItems.forEach(item => item.classList.remove('active-tab--title'));
            tabContentItems.forEach(item => item.classList.remove('active-tab--content'));

           
            tabItem.classList.add('active-tab--title');
          
            tabContentItems[index].classList.add('active-tab--content');

        
            if (index === 0) {
            
                document.querySelectorAll('.containers-container').forEach(item => {
                    item.style.display = 'flex';
                });
           
                document.querySelector('.containers-container-product-information').style.display = 'none';
            }
          
            else if (index === 1) {
            
                document.querySelectorAll('.containers-container').forEach(item => {
                    item.style.display = 'none';
                });
               
                document.querySelector('.containers-container-product-information').style.display = 'block';
            }
        });
    });
});
  
  } catch(e) { console.error(e); }
})();
})();
